import { FedopsInteractions } from './consts';
export const bookingsViewerCacheInteractionStart = _ref => {
  let {
    flowAPI: {
      fedops
    },
    request: {
      method,
      url
    }
  } = _ref;
  fedops.interactionStarted(FedopsInteractions.BOOKINGS_VIEWER_CACHE, {
    customParams: {
      method,
      url
    }
  });
};
export const bookingsViewerCacheInteractionEnd = _ref2 => {
  let {
    flowAPI: {
      fedops
    },
    isError,
    cacheHit
  } = _ref2;
  fedops.interactionEnded(FedopsInteractions.BOOKINGS_VIEWER_CACHE, {
    customParams: isError ? {
      error: true
    } : {
      cacheHit
    }
  });
};
//# sourceMappingURL=fedops.js.map